import BaseService from '@/services/baseService';
import { AxiosResponse } from 'axios';
import { ITakeTeilnehmerService } from './ITakeTeilnehmerService';
import { TakeTeilnehmerApiDto, TeilnehmerListApiDtoSearchResponseApi } from '@/api-schema';
import { TeilnehmerFilterDto } from '@/types/TeilnehmerFilterDto';

export class TakeTeilnehmerService extends BaseService implements ITakeTeilnehmerService {
    private RESOURCE_URL: string;

    constructor() {
        super();
        this.RESOURCE_URL = `${this.BASE_URL}taketeilnehmer/treuhand`;
        console.debug('TakeTeilnehmerService::constructor', this.RESOURCE_URL);
    }

    async takeSpecific(teilnehmer: TakeTeilnehmerApiDto): Promise<boolean | AxiosResponse<any>> {
        // set property to null if not a number
        if (Number(teilnehmer.teilnehmerId) <= 0) {
            teilnehmer.teilnehmerId = null;
        }
        if (Number(teilnehmer.tvsKundennummer) <= 0) {
            teilnehmer.tvsKundennummer = null;
        }

        return super.PUT<TakeTeilnehmerApiDto>(`${this.RESOURCE_URL}`, teilnehmer).then((response) => {
            return response;
        });
    }
    async getTeilnehmer(filter: TeilnehmerFilterDto): Promise<TeilnehmerListApiDtoSearchResponseApi> {
        return super.GET<TeilnehmerListApiDtoSearchResponseApi>(`${this.RESOURCE_URL}${super.serializeObjectToQuerystring(filter)}`).then((response) => {
            return response;
        });
    }
}

export const takeTeilnehmerService = new TakeTeilnehmerService();
